import React, { useState } from 'react'
import Main from '../../cpn/Main'
import { Tabs } from 'antd'
import RuleReportList from './report/RuleReportList'
import RuleIncomeList from './income/RuleIncomeList'
import RuleCostList from './cost/RuleCostList'
import RuleExpenseList from './expense/RuleExpenseList'
import RuleLoanList from './loan/RuleLoanList'
import RuleInvoiceList from './invoice/RuleInvoiceList'
function RuleList(props) {
    const [activeKey, setActiveKey] = useState(localStorage.getItem('jtg-caiwu_rule_active_key') || 'RuleReportList');
    return (
        <>
            <Main 
                selectedKeys={['/RuleList']}
                yh_qx={props.yh_qx}
                qy_id={props.qy_id}
                qy_name={props.qy_name}
                yh_id={props.yh_id}
                yh_name={props.yh_name}
            >
                <Tabs 
                    items={[
                                {
                                    key: 'RuleReportList',
                                    label: '团队报账单',
                                    children: <RuleReportList 
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                        useList={props.useList}
                                        deptList={props.deptList}
                                    />,
                                },
                                {
                                    key: 'RuleIncomeList',
                                    label: '收款单',
                                    children: <RuleIncomeList 
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                        useList={props.useList}
                                        deptList={props.deptList}
                                    />,
                                },
                                {
                                    key: 'RuleCostList',
                                    label: '付款单',
                                    children: <RuleCostList 
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                        useList={props.useList}
                                        deptList={props.deptList}
                                    />,
                                },                              
                                {
                                    key: 'RuleExpenseList',
                                    label: '费用单',
                                    children: <RuleExpenseList 
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                        useList={props.useList}
                                        deptList={props.deptList}
                                    />,
                                },                              
                                {
                                    key: 'RuleLoanList',
                                    label: '借款单',
                                    children: <RuleLoanList 
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                        useList={props.useList}
                                        deptList={props.deptList}
                                    />,
                                },                              
                                {
                                    key: 'RuleInvoiceList',
                                    label: '开票申请',
                                    children: <RuleInvoiceList 
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                        useList={props.useList}   
                                        deptList={props.deptList}
                                    />,
                                },                              
                            ]} 
                    activeKey={activeKey}
                    onChange={(key) => {
                        setActiveKey(key)
                        localStorage.setItem('jtg-caiwu_rule_active_key', key)
                    }}
                />
            </Main>
        </>
    )
}

export default RuleList